module.exports = __webpack_public_path__ + "img/facebook.edd4fb5b.svg";